import { MenuItem, TextField } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { ITimeFilter } from "ui/model"

interface ITimeFilterProps {
  id: string
  label: string
  filters: ITimeFilter[]
  value: ITimeFilter
  disabled?: boolean
  sx?: any
  onChange(newValue: ITimeFilter): any
}

export const TimeFilter = React.memo(
  ({ id, label, filters, value, disabled, onChange, sx }: ITimeFilterProps): JSX.Element => (
    <TextField
      id={id}
      select
      fullWidth
      size="small"
      sx={{ ...sx }}
      label={label}
      value={value.labelKey}
      disabled={disabled}
      onChange={event => onChange(filters.find(f => f.labelKey === event.target.value))}>
      {filters.map(f => (
        <MenuItem key={f.labelKey} value={f.labelKey}>
          {translate(f.labelKey)}
        </MenuItem>
      ))}
    </TextField>
  )
)
